var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{attrs:{"id":_vm.id,"name":_vm.name,"action":_vm.action,"method":_vm.method},on:{"submit":_vm.onSubmit}},_vm._l((_vm.items),function(item,index){return _c('FormElement',{key:(_vm.id + "-" + index),attrs:{"item":item}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }